export default function ChatFormattedText({ text }: { text?: string }) {
  if (!text) return null;

  const parseMarkdown = (text: string) => {
    const parts = text.split(/(\*\*[^*]+\*\*)/g);
    
    return parts.map((part, index) => {
      // If the part is wrapped in **, make it bold
      if (part.startsWith('**') && part.endsWith('**')) {
        return (
          <span key={index} className="font-bold">
            {part.slice(2, -2)}
          </span>
        );
      }
      return part;
    });
  };

  return (
    <p className="break-words whitespace-pre-wrap">
      {parseMarkdown(text)}
    </p>
  );
}
